<template>
    <div class="wrapper">
        <import-table ref="table" :url="url">
            <template v-slot:buttons>
                <div class="dropdown d-inline">
                    <button
                            class="btn btn-secondary dropdown-toggle"
                            type="button"
                            id="dropdownImportMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                    >
                        <i class="far fa-file pr-2"></i>
                    </button>
                    <div class="dropdown-menu compact" aria-labelledby="dropdownImportMenuButton">
                        <a class="dropdown-item" href="#" v-for="item in importOptions" @click="addImport(item)">
                            {{ item.title }}
                        </a>
                    </div>
                </div>
            </template>
        </import-table>
        <filemaker-dialog></filemaker-dialog>
        <do-not-contact-dialog></do-not-contact-dialog>
        <stop-list-dialog></stop-list-dialog>
        <filemaker-with-email-dialog></filemaker-with-email-dialog>
    </div>
</template>

<script>
  import ImportTable from '../../components/import/table';
  import eventBus from '../../event-bus';
  import FilemakerDialog from './dialogs/filemaker-dialog';
  import DoNotContactDialog from './dialogs/do-not-contact-dialog';
  import StopListDialog from './dialogs/stop-list-dialog';
  import FilemakerWithEmailDialog from "./dialogs/filemaker-with-email-dialog.vue";

  export default {
    components: {
      ImportTable,
      FilemakerDialog,
      DoNotContactDialog,
      StopListDialog,
      FilemakerWithEmailDialog,
    },

    props: {
      url: null,
      canCreate: {
        type: Boolean,
        default: false
      },
      importOptions: Array,
    },

    methods: {
      /**
       * @param {string} event
       * @param {object|string} formData
       */
      addImport({event, formData}) {
        event && eventBus.$emit(event, formData);
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },
    },

    created() {
      eventBus.$on('refresh-import-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-import-table', this.refresh);
    }
  }
</script>

<style scoped>
    .dropdown-menu.compact {
        font-size: 0.9em;
    }
</style>
